<aside>
  @if (asidePosition !== 'fixed') {
    <div
      class="aside-expander"
      (click)="toggleAsideFixed()"
    >
      <i class="far fa-right-from-line"></i>
    </div>
  }

  <div class="top-icons">
    <a
      class="top-icon"
      (click)="userMenuOpen = true"
    >
      <motn-user-avatar
        [user]="currentUser"
      ></motn-user-avatar>

      @if (userMenuOpen) {
        <motn-popover-menu
          [menuTitle]="userMenuTitle"
          [optionGroup]="userMenuOptions"
          (clickedAnywhere$)="userMenuOpen = false"
          [overlayPositions]="overlayPositions"
        ></motn-popover-menu>
      }
    </a>

    <a
      [ngClass]="['top-icon', alarmIconColor]"
      routerLink="/alarms"
    >
      <i class="far fa-fw fa-bell"></i>
    </a>

    @if (asidePosition==='fixed') {
      <div
        class="top-icon aside-fixer"
        (click)="toggleAsideFixed()"
      >
        <i class="far fa-fw fa-left-to-line"></i>
      </div>
    }

    @if (asidePosition!=='fixed') {
      <div
        class="top-icon aside-fixer"
        (click)="toggleAsideFixed()"
      >
        <i class="far fa-fw fa-right-from-line"></i>
      </div>
    }
  </div>

  @for (section of allSections; track section.name) {
    <div class="section">
      <div class="name-container">
        <div class="name">
          {{section.name}}
        </div>

        @if (section.shareSubject) {
          <motn-share-button
            [object]="section.shareSubject"
          ></motn-share-button>
        }
      </div>

      @for (item of section.items; track $index) {
        <a class="item">
          <div class="name">
            <div class="expander">
              @if (item.subitems.length) {
                <i class="fa-solid fa-caret-right"></i>
              }
            </div>

            <div class="text">
              <a
                [innerHTML]="item.text"
                [routerLink]="[item.path]"
                [routerLinkActive]="'active'"
              ></a>

              @if (item.iconItems) {
                <span>
                  @for (iconItem of item.iconItems; track $index) {
                    <a
                      class="icon-item"
                      [routerLink]="[iconItem.path]"
                      [routerLinkActive]="'active'"
                    >
                      <i class="fa-regular fa-{{iconItem.icon}}"></i>
                    </a>
                  }
                </span>
              }
            </div>
          </div>
        </a>
      }
    </div>
  }
</aside>
